// extracted by mini-css-extract-plugin
module.exports = {"header":"mainDialog_header__2iS1x","actions":"mainDialog_actions__1GaJo","close":"mainDialog_close__3RzAv"};